import React, { useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { QuotationForm } from './QuotationForm';

export function NewQuotation() {
  const navigate = useNavigate();

  const handleClose = useCallback(() => {
    navigate('/quotations');
  }, [navigate]);

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <div className="mb-8">
        <Link
          to="/quotations"
          className="flex items-center text-sm text-indigo-600 hover:text-indigo-900"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to Quotations
        </Link>
      </div>

      <div className="bg-white shadow-lg rounded-lg">
        <div className="px-6 py-4 border-b border-gray-200">
          <h1 className="text-xl font-semibold text-gray-900">New Quotation</h1>
        </div>
        <div className="p-6">
          <QuotationForm onClose={handleClose} />
        </div>
      </div>
    </div>
  );
}